import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
export default class SimpleDate extends PureComponent {
    render() {
        const { date } = this.props;
        return React.createElement("span", null, new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }));
    }
}
SimpleDate.propTypes = { date: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) };
